import { render } from "./FilePicker.vue?vue&type=template&id=4e22de5b&scoped=true"
import script from "./FilePicker.vue?vue&type=script&lang=js"
export * from "./FilePicker.vue?vue&type=script&lang=js"

import "./FilePicker.vue?vue&type=style&index=0&id=4e22de5b&lang=sass&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e22de5b"]])

export default __exports__